import { useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import FilterColumn from "src/components/Table/FilterColumn";
import { FilterFn } from "src/components/Table/FilterFn";
import { numberWithCommas } from "src/utils/thousandSeprator";
import moment from 'jalali-moment';
import Accordion from "src/components/Accordion";
import { TbHelpSquareRounded } from "react-icons/tb";
import Hintbox from "src/components/Hintbox";


export default function Invoices() {
    const [invoices, setInvoices] = useState()

    useEffect(() => {
        getData((invoices) => {
            let filteredInvoices = invoices.filter(invoice => {
                if (invoice.customerPartyRef == 48) {
                    return true
                }
            })
            setInvoices(filteredInvoices)
        }, "/sepidar/invoices")
    }, [])

    const columns = [
        {
            id: "invoiceId",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شناسه",
        },
        {
            id: "number",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شماره فاکتور",
        },
        {
            id: "customerPartyName",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نام مشتری",
        },
        {
            id: "slTitle",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "حساب معین",
        },
        {
            id: "saleTypeTitle",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نوع فروش",
        },
        {
            id: "priceInBaseCurrency",
            cell: (info) => numberWithCommas(parseInt(info.getValue())) + " ریال",
            header: "بها",
        },
        {
            id: "discountInBaseCurrency",
            cell: (info) => numberWithCommas(parseInt(info.getValue())) + " ریال",
            header: "تخفیف",
        },
        {
            id: "additionInBaseCurrency",
            cell: (info) => numberWithCommas(parseInt(info.getValue())) + " ریال",
            header: "اضافات",
        },
        {
            id: "taxInBaseCurrency",
            cell: (info) => numberWithCommas(parseInt(info.getValue())) + " ریال",
            header: "مالیات",
        },
        {
            id: "netPriceInBaseCurrency",
            cell: (info) => numberWithCommas(parseInt(info.getValue())) + " ریال",
            header: "بها خالص",
        },
        {
            id: "stateTitle",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "وضعیت",
        },
        {
            id: "note",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "یادداشت",
        },
        {
            id: "creationDate",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue(), "en", "YYYY-MM-DD HH:mm:ss")
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            filterFn: (row, columnId, filterValue) => {
                // type can be "object" , "array" , "string" , "number"
                return FilterFn(row, columnId, filterValue, "date");
            },
            meta: {
                filterComponent: (setFilterValue) => {
                    return <FilterColumn setFilterValue={setFilterValue} type="date" />;
                },
            },
            header: "تاریخ ایجاد",
        },
        {
            id: "lastModificationDate",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue(), "en", "YYYY-MM-DD HH:mm:ss")
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            filterFn: (row, columnId, filterValue) => {
                // type can be "object" , "array" , "string" , "number"
                return FilterFn(row, columnId, filterValue, "date");
            },
            meta: {
                filterComponent: (setFilterValue) => {
                    return <FilterColumn setFilterValue={setFilterValue} type="date" />;
                },
            },
            header: "تاریخ آخرین ویرایش",
        },
    ];

    return (
        <>
            <PageHeader
                title="لیست فاکتورهای فروش"
            />
             <Accordion title="نکات راهنما" icon={<TbHelpSquareRounded className="text-gray-400" />} hasVerticalLine={true} >
                <Hintbox text="در هر شبانه روز در ساعت 00:05 بامداد ثبت فاکتورهای فروش 5 روز قبل اجرا می‌شود و چهار نوع فاکتور فروشی(فروش از وبسایت) اسنپ پی، اسنپ شاپ و تپسی شاپ صادر میشوند. برای اطمینان از ثبت صحیح فاکتورها بخش فاکتورهای خطا دار را چک کنید.." type="info"/>
                <Hintbox text="یادداشت‌های فاکتور تنها در این قسمت قابل مشاهده هستند و در سپیدار نمایش داده نمی‌شوند." type="info"/>
                <Hintbox text="رعایت ترتیب شماره‌های فاکتور الزامی است. بنابراین در صورت اشتباه برای حذف تاثیر فاکتورها، بجای حذف آن‌ها از گزینه ابطال فاکتور در سپیدار استفاده کنید." type="alert"/>
             </Accordion>
            <Table data={invoices} columns={columns} CSVExportPermission="exportInvoices" />
        </>
    )
}
